export const legalDocumentVersions = {
  legal: "2026-05-19",
  terms: "2026-05-19",
  privacy: "2026-05-19",
  cookies: "2026-05-19",
  dpa: "2026-05-19",
  subprocessors: "2026-05-19",
  acceptable_use: "2026-05-19",
  security: "2026-05-19",
  retention: "2026-05-19",
  support: "2026-05-19",
  vulnerability_disclosure: "2026-05-19",
  billing: "2026-05-19",
  sandbox_disclaimer: "2026-05-19",
  website_terms: "2026-05-19"
} as const;

export type LegalDocumentKey = keyof typeof legalDocumentVersions;

export const requiredLegalAcceptanceDocuments = {
  terms: legalDocumentVersions.terms,
  privacy: legalDocumentVersions.privacy,
  dpa: legalDocumentVersions.dpa
} as const;
